import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Build = lazy(() => import('./components/pages/Build').then(({Build}) => ({default: Build})))

export function BuildPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Build'))

  return (
    <Suspense>
      <Build activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the building module.
 */
export const buildRoutes = [
  {
    index: true,
    element: <BuildPage />,
  },
]
